export const isValidFileUploaded = (file)=>{
    const validExtensions = ['png','jpeg','jpg', 'svg', 'ico', 'jfif', 'webp']
    const fileExtension = file && file.type.split('/')[1]
    const fileSize = file.size
    if (fileSize < 10485760 && validExtensions.includes(fileExtension))
        return true
    else 
        return false

}
